import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppSelector, useAppDispatch } from '../hooks';
import Modal from 'react-modal';
import { hideDialog } from '../reducers/app';
Modal.setAppElement('#root');
export const Dialog = (props) => {
    const dispatch = useAppDispatch();
    const visible_dialog = useAppSelector(state => state.app.visible_dialog);
    const modal = visible_dialog == props.id;
    let footer = null;
    if (props.footer) {
        footer = (_jsx("div", { className: "modaldialogfooter modal-footer", children: props.footer }));
    }
    else if (props.footerleft || props.footerright) {
        footer = (_jsxs("div", { className: "modaldialogfooter", style: { display: 'flex' }, children: [_jsx("div", { children: props.footerleft }), _jsx("div", { style: { marginLeft: 'auto' }, children: props.footerright })] }));
    }
    return (_jsxs(Modal, { isOpen: modal, onRequestClose: () => dispatch(hideDialog()), className: "modaldialog", contentLabel: props.title, overlayClassName: "modaldialogoverlay", children: [_jsxs("div", { className: "modaldialogheader", children: [_jsx("div", { className: "title", children: props.title }), _jsx("button", { type: "button", className: "close", onClick: () => dispatch(hideDialog()), children: _jsx("span", { "aria-label": "Close", children: "\u00D7" }) })] }), _jsx("div", { className: "modaldialogbody", children: props.children }), footer] }));
};
